import { getAllInboundApplicationForms, getInboundFormsConversionRates } from '@/services/inboundForm.service';

import { getInboundApplicationList } from '../../services/inbound.service';
import { applicationFetchLimit } from '../../utils/constants';
import {
  EVICT_APPLICATION_CACHE,
  FETCH_ALL_INBOUND_FORMS,
  FETCH_APPLICATION_FORM_CONVERSION_RATES_REQUEST,
  FETCH_APPLICATION_FORM_CONVERSION_RATES_SUCCESS,
  FETCH_APPLICATION_REQUEST,
  FETCH_APPLICATION_SUCCESS,
  SET_APPLICATION_COUNT,
} from './applicationType';

export const fetchApplicationsRequest = () => {
  return {
    type: FETCH_APPLICATION_REQUEST,
  };
};

export const fetchApplicationsSuccess = (applications) => {
  return {
    type: FETCH_APPLICATION_SUCCESS,
    payload: applications,
  };
};

export const setApplicationCount = ({ count, approvalStatus }) => {
  return {
    type: SET_APPLICATION_COUNT,
    payload: {
      count,
      approvalStatus,
    },
  };
};

export const evictApplicationsCache = () => {
  return {
    type: EVICT_APPLICATION_CACHE,
  };
};

export const setAllInboundApplicationForms = (forms) => {
  return {
    type: FETCH_ALL_INBOUND_FORMS,
    payload: forms,
  };
};

export const fetchApplicationsFormsConversionRateRequest = () => {
  return {
    type: FETCH_APPLICATION_FORM_CONVERSION_RATES_REQUEST,
  };
};

export const setInboundFormsConversionRatesSuccess = (payload) => {
  return {
    type: FETCH_APPLICATION_FORM_CONVERSION_RATES_SUCCESS,
    payload,
  };
};

export const evictApplicationsAndRefetch =
  ({ approvalStatus, formIds }) =>
  (dispatch) => {
    dispatch(fetchApplicationsRequest());
    dispatch(evictApplicationsCache());
    dispatch(fetchApplications({ approvalStatus, formIds }));
  };

export const getInboundApplicationsCacheKey = (args) => {
  const approvalStatus = args?.approvalStatus || 'pending';
  const pageSize = args?.pageSize || applicationFetchLimit;
  const currentPage = args?.currentPage || 1;
  const searchQuery = args?.searchQuery || '';
  const formIds = args?.formIds || [];
  return `${approvalStatus}-${pageSize}-${currentPage}-${searchQuery}-${formIds.join(',')}`;
};

export const fetchApplications = (args) => {
  return async (dispatch) => {
    const approvalStatus = args?.approvalStatus || 'pending';
    const pageSize = args?.pageSize || applicationFetchLimit;
    const currentPage = args?.currentPage || 1;
    const formIds = args?.formIds || [];
    const searchQuery = args?.searchQuery || '';
    const key = getInboundApplicationsCacheKey({ approvalStatus, pageSize, currentPage, searchQuery, formIds });
    dispatch(fetchApplicationsRequest());
    const response = await getInboundApplicationList({
      approvalStatus,
      pageSize,
      currentPage,
      formIds,
    });
    if (response?.status) {
      dispatch(
        fetchApplicationsSuccess({
          applications: response.data.inboundApplicationList,
          key,
        })
      );

      dispatch(setApplicationCount({ approvalStatus: key, count: response.data.total }));
    } else {
      dispatch(fetchApplicationsSuccess({ applications: [], key }));
    }
  };
};

export const searchApplications = (args) => {
  return async (dispatch) => {
    const approvalStatus = args?.approvalStatus || 'pending';
    const pageSize = args?.limpageSizeit || applicationFetchLimit;
    const currentPage = args?.currentPage || 1;
    const searchQuery = args?.searchQuery;
    const formIds = args?.formIds || [];
    const key = getInboundApplicationsCacheKey({ approvalStatus, pageSize, currentPage, searchQuery, formIds });
    dispatch(fetchApplicationsRequest());
    const response = await getInboundApplicationList({
      approvalStatus,
      pageSize,
      currentPage,
      searchQuery,
      formIds,
    });
    if (response?.status) {
      dispatch(
        fetchApplicationsSuccess({
          applications: response.data.inboundApplicationList,
          key,
        })
      );
      dispatch(
        setApplicationCount({
          approvalStatus: key,
          count: response.data.total,
        })
      );
    } else {
      dispatch(fetchApplicationsSuccess({ applications: [], key }));
    }
  };
};

export const fetchAllInboundApplicationForms = () => {
  return async (dispatch) => {
    const response = await getAllInboundApplicationForms();
    if (response?.status) {
      dispatch(setAllInboundApplicationForms(response.data));
    }
  };
};

export const fetchInboundFormConversionRates = (formIds) => {
  return async (dispatch) => {
    dispatch(fetchApplicationsFormsConversionRateRequest());
    const response = await getInboundFormsConversionRates({ formIds });
    if (response?.status) {
      dispatch(setInboundFormsConversionRatesSuccess(response.data));
    }
  };
};
